import axios from 'axios';
import Button from 'components/UI/Button/Button';
import React, { useEffect, useState } from 'react';
import useSound from 'use-sound';
import { HookOptions } from 'use-sound/dist/types';

function useCustomAudio({ word, phoneme }: { word: string; phoneme: string }) {
    const [soundUrl, setSoundUrl] = useState('');

    const shouldPlay = true;

    const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    };

    useEffect(() => {
        if (!shouldPlay) return;

        axios
            .post(
                'https://texttospeech.googleapis.com/v1beta1/text:synthesize?key=AIzaSyCJvhqqXiHljFhTjTrVDVZtSrYbQcxshRM',
                {
                    input: {
                        ssml: `<speak><phoneme alphabet="x-sampa" ph='${phoneme}'>${word}</phoneme> </speak>`,
                    },
                    voice: {
                        languageCode: 'nl-nl',
                        name: 'nl-NL-Wavenet-D',
                        ssmlGender: 'FEMALE',
                    },
                    audioConfig: {
                        audioEncoding: 'MP3',
                        speakingRate: 1,
                        volumeGainDb: 6,
                    },
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then((response) => {
                const blob = b64toBlob(
                    response.data.audioContent,
                    'audio/mpeg'
                );
                const urlResult = window.URL.createObjectURL(blob);
                setSoundUrl(urlResult);
            });
    }, [word, phoneme]);

    const [play, { stop, isPlaying, sound, duration }] = useSound(soundUrl, {
        format: 'mp3',
    } as HookOptions);

    const url = sound?._src;

    useEffect(() => () => stop(), [url]);

    return { play, stop, isPlaying, url, duration };
}

export default function TestAudio() {
    const [word, setWord] = useState('');
    const [phoneme, setPhoneme] = useState('');

    const { play } = useCustomAudio({ word, phoneme });

    return (
        <div style={{ margin: 10 }}>
            <p>
                Woord:{' '}
                <input
                    type="text"
                    value={word}
                    placeholder="Woord invoeren"
                    onChange={(e) => setWord(e.target.value)}
                />
            </p>
            <p>
                Phoneme:{' '}
                <input
                    type="text"
                    value={phoneme}
                    placeholder="Phoneme invoeren (X-SAMPA)"
                    onChange={(e) => setPhoneme(e.target.value)}
                />
            </p>

            <Button onClick={() => play()}>Spreek uit</Button>
        </div>
    );
}
